import { render, staticRenderFns } from "./PrintPosFaMed.vue?vue&type=template&id=352c79c8&scoped=true"
import script from "./PrintPosFaMed.vue?vue&type=script&lang=js"
export * from "./PrintPosFaMed.vue?vue&type=script&lang=js"
import style0 from "./PrintPosFaMed.vue?vue&type=style&index=0&id=352c79c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352c79c8",
  null
  
)

export default component.exports